module.exports = __webpack_public_path__ + "img/logo_agap_ami2_72dpi.222c07ec.png";